import { render, staticRenderFns } from "./CrudV1.vue?vue&type=template&id=0c7b4891&scoped=true&"
import script from "./CrudV1.vue?vue&type=script&lang=js&"
export * from "./CrudV1.vue?vue&type=script&lang=js&"
import style0 from "./CrudV1.vue?vue&type=style&index=0&id=0c7b4891&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b4891",
  null
  
)

export default component.exports